import headerImg from '../../../assets/developers/devbanner.svg'

import ease from '../../../assets/developers/ease.svg'
import growth from '../../../assets/developers/growth.svg'
import speed from '../../../assets/developers/speed.svg'

import whyChoose from '../../../assets/developers/whyChoose.svg'


export const headerData = {
    title: 'Flutter',
    title2: 'Developers',
    desc: 'Flutter is an open-source mobile application development framework created by Google. It allows developers to build native apps for both Android and iOS platforms using a single codebase. Flutter uses Dart, a modern programming language that provides a range of features, such as garbage collection and just-in-time compilation, making it easier and faster to develop and maintain mobile applications.',
    points: [
        'Quick deployment',
        'An active community with open-source solutions',
        'Shorter time-to-market circle',
    ],
    img: headerImg
}

export const achiveData = {
    title1: 'What can you Achieve with the right',
    title2: 'Flutter Developers?',
    desc: "You need a Flutter team that never compromises on your project’s success determinants. Let's find out what a field-proven team looks like",
    cards: [
        {
            title: 'Growth with Confidence',
            desc: 'Start small but go big with CodeZone’s Flutter developers, who leverage seamless and cost-effective cloud computing tools to expand your user base.',
            img: ease
        },
        {
            title: 'Ease of Flexibility',
            desc: 'Node-to-node technology facilitates Flutter developers to smoothly integrate changes without altering the core programming source, contributing to easier maintenance.',
            img: growth
        },
        {
            title: 'Speed and Performance',
            desc: 'Flutter experts integrate uninterrupted speed and performance to handle high traffic, making Flutter an ideal framework for developing user-centric apps.',
            img: speed
        },


    ]
}

export const partnerData = {
    title1: 'Partner With CodeZone for Future-forward',
    title2: 'Flutter App Development Services',

    cards: [
        {
            title: 'Truly Agile Procedures',
            desc: "CodeZone's Flutter developers follow the time-tested agile practices throughout the software development life cycle — ensuring efficiency and transparency.",
        },
        {
            title: 'Custom Flutter development services',
            desc: 'CodeZone is a houseful of Flutter experts and tech stack that fit faultlessly with your product and company culture.',
        },
        {
            title: 'Market competitive Rates',
            desc: "We provide silicon-valley level Flutter experts under budget-friendly pricing. With us, you wouldn't have to worry about your budget and the quality, because we care for both.",
        },
        {
            title: 'Dedicated Flutter Mobile App Development Teams',
            desc: "The dedicated development team co-acts with your in-house team. Borders, languages, or cultures never stop us from delivering a global enterprise-level product.",
        },


    ]
}

export const whyChooseData = {
    title: 'Flutter',
    desc: 'Easy. Awesome. Powerful. Fast. Flexible. Fun. – All under Flutter Umbrella.',
    img: whyChoose,
    cards: [
        {
            title: 'High Performance',
            desc: 'Outperform the competition with the single-threaded and event-driven architecture of Flutter.'
        },
        {
            title: 'Easy Scalability',
            desc: 'Handle a huge number of concurrent connections and develop lightweight systems with Flutter.'
        },
        {
            title: 'Microservices',
            desc: 'Build powerful microservice-based web applications with Flutter developers.'
        },
        {
            title: 'Custom Software Development',
            desc: 'Leverage built-in API through Flutter as it can be easily extended and customized.'
        },
        {
            title: 'Fast Time-to-Market',
            desc: 'Speed up the development process with multiple frameworks and libraries of Flutter.'
        },
        {
            title: 'Community Support',
            desc: 'Expect extensive support from hawk-eyed developers of the Flutter community.'
        },
    ]
}

export const HowToData = {
    title : 'Flutter developers',
    desc : 'A meticulous process for impeccable product launch without any delays',
}

export const FAQData = [
    {
        question: 'What is Flutter?',
        answer: 'Flutter is an open-source mobile application development framework created by Google. It allows developers to build native apps for both Android and iOS platforms using a single codebase.'
    },
    {
        question: 'What programming language does Flutter use?',
        answer: 'Flutter uses Dart, a modern programming language that provides a range of features, such as garbage collection and just-in-time compilation, making it easier and faster to develop and maintain mobile applications.'
    },
    {
        question: 'Can I use Flutter to build web applications?',
        answer: "Yes, Flutter allows developers to build web applications as well, using the same codebase that they use for mobile apps."
    },
 

]